const uniqueObjectsFilter = {
  install(Vue) {
    Vue.filter('uniqueObjects', (data, key) => {
      if (data && key) {
        return [...new Map(data.map((item) => [item[key], item])).values()];
      }
      return [];
    });
  },
};

export default uniqueObjectsFilter;
